import { useSelector } from 'react-redux'

import { selectTerritoryNotificationBehavior } from '@/features/domain/territory'

export function useNotificationBehavior() {
  const notificationBehavior = useSelector(selectTerritoryNotificationBehavior)

  return notificationBehavior
}
